import { setObjectTypes } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@casops/filters/types';
import MultiselectFilter from '../multiselect/MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { getObjectTypeFromEnum } from '@casops/shared/utils/translationHelpers';
import { ObjectType } from '@casops/store/apis/commonModels';

export const useObjectTypeOptions = (): DropdownItemProps<ObjectType>[] => {
  const { t } = useTranslation();
  return useMemo(() => {
    return Object.keys(ObjectType)
      .map((key: string) => {
        const value = ObjectType[key as keyof typeof ObjectType];
        return { key: value, value, stringValue: value, label: t(getObjectTypeFromEnum(t, value)) };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [t]);
};

export const ObjectTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();
  return (
    <MultiselectFilter<ObjectType>
      filterName="objectTypes"
      label={label ?? t('Fields.Filters.ObjectType')}
      action={setObjectTypes}
      elementRef={elementRef}
      useItemsHook={useObjectTypeOptions}
    />
  );
};

export default ObjectTypesFilter;
